import * as React from 'react';
import { FC, useEffect } from 'react';

interface IngredientValuesModel {
    amount: number,
    unit: string,
    unitPluralName: string,
    portions: number,
    defaultPortions: number,
}

const IngredientValue: FC<IngredientValuesModel> = (props) => {
    // When the ingredient has one of these units, render the number as decimal instead of as a fraction
    const DECIMAL_UNITS = [
        'mg',
        'g',
        'hg',
        'kg',
        'ml',
        'cl',
        'dl',
        'l'
    ]

    const [displayValue, setDisplayValue] = React.useState(props.portions.toLocaleString());

    useEffect(() => {
        const value = useFractions() ? formatValue( valueInt() ) : valueLocale();
        setDisplayValue(value.toLocaleString());
    }, [props.portions]);

    // Check if fractions
    const useFractions = () => {
      return !props.unit || !DECIMAL_UNITS.includes(props.unit)
    };

    const valueInt = () => {
      if (props.defaultPortions !== 0) {
        return props.portions * (props.amount / props.defaultPortions)
      } else {
        return props.amount;
      }      
    };

    const valueLocale = () => {
        // The value is divided by the default number of portions for the recipe,
        // them multiplied by the chosen number of portions
        return (Math.round(valueInt() * 100) / 100).toLocaleString()
    };

    const formatValue = (value: number) => {
      // The value is formatted to substitute 0.5 for 1/2, 0.25 for 1/4 and to round other decimal values
      const wholeNumber = Math.floor(value);
      const decimalValue = value - wholeNumber;

      if (!props.unit || DECIMAL_UNITS.includes(props.unit)) {
        return props.amount;
      }

      if( decimalValue === 0 ) {
        return wholeNumber
      } else {
        switch( decimalValue ) {
          case 1/2: { return `${wholeNumber || ''}½`; break }
          case 1/3: { return `${wholeNumber || ''}⅓`; break }
          case 2/3: { return `${wholeNumber || ''}⅔`; break }
          case 1/4: { return `${wholeNumber || ''}¼`; break }
          case 3/4: { return `${wholeNumber || ''}¾`; break }
          case 1/8: { return `${wholeNumber || ''}⅛`; break }
          case 3/8: { return `${wholeNumber || ''}⅓`; break } // ~ About 1/3
          case 5/8: { return `${wholeNumber || ''}⅔`; break } // ~ About 2/3
          default: return (Math.round(value * 100) / 100).toLocaleString()
        }
      }
    }

    return (
        <>
            {displayValue}&nbsp;

            {props.amount > 0 && props.unit !== 'stk' && (
                <>
                    {props.amount <=1 ? (
                        <span>
                            {props.unit}&#32;
                        </span>
                    ) : (
                        <span>
                            {props.unitPluralName}&#32;
                        </span>
                    )}
                </>
            )}
        </>
    );
};
export default IngredientValue;